import moment from "moment";

export class ExerciseStatsCalculator {

	static computeEstimated1RM(weight, reps) {
		if (reps <= 0 || weight <= 0) return 0;
		if (reps === 1) return weight;
		if (reps >= 37) return 0;
		return weight * 36 / (37 - reps);
	}

	static getEstimated1RMPerSession(logGroups) {
		const results = [];
		for (const group of logGroups) {
			let bestE1RM = 0;
			for (const log of group.logs) {
				if (log.values.length >= 2 && log.values[0] > 0 && log.values[1] > 0) {
					const e1rm = this.computeEstimated1RM(log.values[0], log.values[1]);
					if (e1rm > bestE1RM) bestE1RM = e1rm;
				}
			}
			if (bestE1RM > 0) {
				results.push({ date: group.date, value: Math.round(bestE1RM * 10) / 10 });
			}
		}
		return results;
	}

	static getTrainingPatterns(logGroups) {
		if (!logGroups || logGroups.length === 0) return null;

		const allValues0 = [];
		const allValues1 = [];
		const allRpe = [];
		const allRir = [];
		let totalSets = 0;

		for (const group of logGroups) {
			for (const log of group.logs) {
				totalSets++;
				if (log.values[0] != null) allValues0.push(log.values[0]);
				if (log.values.length >= 2 && log.values[1] != null) allValues1.push(log.values[1]);
				if (log.rpeValue != null) allRpe.push(log.rpeValue);
				if (log.rirValue != null) allRir.push(log.rirValue);
			}
		}

		const totalSessions = logGroups.length;
		const avgSetsPerSession = totalSessions > 0 ? Math.round(totalSets / totalSessions * 10) / 10 : 0;

		// Frequency: sessions per month
		let sessionsPerMonth = null;
		if (totalSessions >= 2) {
			const dates = logGroups.map(g => moment(g.date));
			const earliest = moment.min(dates);
			const latest = moment.max(dates);
			const months = latest.diff(earliest, 'months', true);
			if (months > 0.25) {
				sessionsPerMonth = Math.round(totalSessions / months * 10) / 10;
			}
		}

		// Most common rep range (for exercises with reps in values[1])
		let repRange = null;
		if (allValues1.length > 0) {
			const sorted = [...allValues1].sort((a, b) => a - b);
			const p25 = sorted[Math.floor(sorted.length * 0.25)];
			const p75 = sorted[Math.floor(sorted.length * 0.75)];
			repRange = { low: Math.round(p25), high: Math.round(p75) };
		}

		// Most used weight (mode of values[0], rounded)
		let mostUsedWeight = null;
		if (allValues0.length > 0) {
			const freq = {};
			for (const v of allValues0) {
				const rounded = Math.round(v * 2) / 2; // round to nearest 0.5
				freq[rounded] = (freq[rounded] || 0) + 1;
			}
			let maxCount = 0;
			for (const [val, count] of Object.entries(freq)) {
				if (count > maxCount) {
					maxCount = count;
					mostUsedWeight = parseFloat(val);
				}
			}
		}

		// Average RPE
		const avgRpe = allRpe.length >= 3 ? Math.round(allRpe.reduce((a, b) => a + b, 0) / allRpe.length * 10) / 10 : null;

		// Average RIR
		const avgRir = allRir.length >= 3 ? Math.round(allRir.reduce((a, b) => a + b, 0) / allRir.length * 10) / 10 : null;

		return {
			avgSetsPerSession,
			sessionsPerMonth,
			repRange,
			mostUsedWeight,
			avgRpe,
			avgRir,
			hasRpeData: allRpe.length >= 3,
			hasRirData: allRir.length >= 3,
		};
	}
}
